// extracted by mini-css-extract-plugin
module.exports = {"forrest100":"#EBF6F2","container":"SavingsBanner_container__d1xOu","textContainer":"SavingsBanner_textContainer__W1xGp"};